import React, { createContext, useContext } from "react";
import type { ClientDetail, MembershipRole } from "./types";

export type ClientContextValue = {
  client: ClientDetail;
  /** The caller's role in this client. Null for a BKDP admin without a membership. */
  role: MembershipRole | null;
  isBkdpAdmin: boolean;
  /** True when the caller may manage documents and members for this client. */
  canManage: boolean;
  refreshClient: () => Promise<void>;
};

const ClientContext = createContext<ClientContextValue | undefined>(undefined);

export const ClientContextProvider: React.FC<
  React.PropsWithChildren<{ value: ClientContextValue }>
> = ({ value, children }) => (
  <ClientContext.Provider value={value}>{children}</ClientContext.Provider>
);

/** Available inside /c/:slug routes and every client application. */
export const useClient = (): ClientContextValue => {
  const ctx = useContext(ClientContext);
  if (!ctx) {
    throw new Error("useClient must be used within a client portal route");
  }
  return ctx;
};
